import { jsx as i, jsxs as u } from "react/jsx-runtime";
import { forwardRef as b } from "react";
import c from "classnames";
import t from "./index.es666.js";
import { GoogleLogin as I } from "react-google-login";
import { GOOGLE_CLIENT_ID as G } from "./index.es667.js";
import { GoogleIcon as _ } from "./index.es419.js";
const p = "sign-in-with-google-button", E = b(
  ({
    size: s = "default",
    onSuccess: n,
    onError: e,
    fullWidth: r = !1,
    label: l = "Sign in with Google",
    testId: a = p,
    googleClientId: d = G,
    cookiePolicy: m = "single_host_origin",
    ...f
  }, g) => /* @__PURE__ */ i(
    I,
    {
      clientId: d,
      render: (o) => /* @__PURE__ */ u(
        "button",
        {
          "data-testid": a,
          type: "button",
          onClick: o.onClick,
          disabled: o.disabled,
          ref: g,
          className: c(t.button, [t[`button--size-${s}`]], {
            [t["button--full-width"]]: r,
            [t["button--disabled"]]: o.disabled
          }),
          "aria-label": l,
          ...f,
          children: [
            /* @__PURE__ */ i(_, { size: 16 }),
            /* @__PURE__ */ i("span", { children: l })
          ]
        }
      ),
      onSuccess: (o) => {
        n && "tokenId" in o && n(o.tokenId);
      },
      onFailure: (o) => {
        e && e(o.error);
      },
      cookiePolicy: m
    }
  )
);
export {
  p as SIGN_IN_GOOGLE_BUTTON_DEFAULT_TESTID,
  E as SignInGoogleButton
};
//# sourceMappingURL=index.es10.js.map
